module.exports = {"130304001":"西山街道","130304002":"东山街道","130304100":"海滨镇","130304101":"戴河镇","130304103":"牛头崖镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130304.json
// module id = 102
// module chunks = 0